





























































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { ja } from 'vuejs-datepicker/dist/locale'
import { MetaInfo } from 'vue-meta'
import { common } from '@/app/model/store/domain/const'

/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'

/* module */
import CommonClass from '@/app/module/common'
import NewsBoardContentValidator from '@/app/module/validator/newsBoardContentValidator'
import NewsBoardDetailApi from '@/app/model/api/newsBoardDetailApi'
import NewsBoardContentCreateApi from '@/app/model/api/newsBoardContentCreateApi'
import NewsBoardContentDetailApi from '@/app/model/api/newsBoardContentDetailApi'
import NewsBoardContentEditApi from '@/app/model/api/newsBoardContentEditApi'
import NewsBoardContentDeleteApi from '@/app/model/api/newsBoardContentDeleteApi'
import GetNewsBoardFileApi from '@/app/model/api/getNewsBoardFileApi'

import Datepicker from 'vuejs-datepicker'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo,
    Datepicker
  },
  metaInfo (this: NewsBoardContentCreate): MetaInfo {
    return {
      title: this.setPageTitle
    }
  }
})
export default class NewsBoardContentCreate extends Vue {
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private newsBoardName: string = ''
  private newsBoardContentName: string = ''
  private newsBoardId: string = ''
  private newsBoardContentId: string = ''
  private newsBoardContentDate: any = new Date()
  private contentURL: string = ''

  /* 表示非表示 */
  private showLoading: boolean = true
  private showServerErrorModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false
  private createModeFlag: boolean = true

  private contentOptions: any = [
    { text: 'ファイル', value: 0 },
    { text: 'URL', value: 1 }
  ]
  private contentSelected: number = 0
  private newsBoardDetailData: any = {}
  private newsBoardContentDetailData: any = {}
  private uploadFile: any = null
  private remarks: string = ''
  private japanese: any = ja
  private fileName: string = ''
  private newsBoardTitle: string = ''
  private newsBoardHeaderTitle: string = ''

  private get setPageTitle () {
    let title = ''
    if (this.$route.path === '/news-board/' + this.newsBoardId + '/content/create') {
      title = CommonClass.getServiceFunctionData().news_board.news_board_name + '記事追加 | ' + common.SYSTEM_NAME
    } else {
      title = CommonClass.getServiceFunctionData().news_board.news_board_name + '記事編集・削除 | ' + common.SYSTEM_NAME
    }
    return title
  }

  created () {
    this.newsBoardTitle = CommonClass.getServiceFunctionData().news_board.news_board_name
    this.newsBoardId = this.$route.params.news_board_id
    this.getNewsBoardDetail(this.newsBoardId)

    const path = '/news-board/' + this.newsBoardId + '/content/create'
    if (this.$route.path === path) {
      this.newsBoardHeaderTitle = this.newsBoardTitle + '記事追加'
      this.createModeFlag = true
    } else {
      this.newsBoardHeaderTitle = this.newsBoardTitle + '記事編集・削除'
      this.createModeFlag = false
      this.newsBoardContentId = this.$route.params.news_board_content_id
      this.getNewsBoardContentDetail(this.newsBoardContentId)
    }
  }

  private saveNewsBoardContent () {
    if (this.validNewsBoard()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    if (this.createModeFlag) {
      this.createNewsBoardContent()
    } else {
      this.updateNewsBoard()
    }
  }

  private async createNewsBoardContent () {
    this.showLoading = true
    const requestBody: any = {
      news_board_id: this.newsBoardId,
      content_name: this.newsBoardContentName,
      record_date: this.createYYYYmmdd(this.newsBoardContentDate),
      remarks: this.remarks,
      url: this.contentSelected === 1 ? this.contentURL : ''
    }

    const result = await NewsBoardContentCreateApi.doNewsBoardContentCreate(requestBody, this.uploadFile)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.newsBoardTitle + '記事追加が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      const path = '/news-board/' + this.newsBoardId
      this.$router.push(path).catch(e => {})
      this.showLoading = false
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
      this.showLoading = false
    }
  }

  private validNewsBoard (): boolean {
    let isValid = false
    if (NewsBoardContentValidator.validRequireNewsBoardContentName('newsBoardContentNameErrorMessage', this.newsBoardContentName)) {
      isValid = true
    }

    if (NewsBoardContentValidator.validMaxLengthNewsBoardContentName('newsBoardContentNameMaxLengthErrorMessage', this.newsBoardContentName)) {
      isValid = true
    }

    if (NewsBoardContentValidator.validRequiredContentDate('contentDateErrorMessage', this.newsBoardContentDate)) {
      isValid = true
    }

    if (this.contentSelected === 1 && NewsBoardContentValidator.validRequireContentUrl('contentUrlErrorMessage', this.contentURL)) {
      isValid = true
    }

    if (this.contentSelected === 1 && NewsBoardContentValidator.validMaxLengthContentUrl('contentUrlMaxLengthErrorMessage', this.contentURL)) {
      isValid = true
    }
    if (this.uploadFile !== null) {
      if (this.contentSelected === 0 && NewsBoardContentValidator.validRequireContentFile('fileErrorMessage', this.uploadFile)) {
        isValid = true
      } else if (this.contentSelected === 0 && NewsBoardContentValidator.validFileTypeContentFile('fileErrorMessage', this.uploadFile)) {
        isValid = true
      } else if (this.contentSelected === 0 && NewsBoardContentValidator.validMaxFileSize('fileErrorMessage', this.uploadFile.size)) {
        isValid = true
      }
    } else {
      if (this.contentSelected === 0 && NewsBoardContentValidator.validRequireContentFile('fileErrorMessage', this.fileName)) {
        isValid = true
      }
    }

    if (NewsBoardContentValidator.validMaxLengthRemarks('remarksErrorMessage', this.remarks)) {
      isValid = true
    }

    this.errorMessages = Object.assign({}, this.errorMessages, NewsBoardContentValidator.getErrorMessage())
    return isValid
  }

  private async updateNewsBoard () {
    this.showLoading = true
    const requestBody: any = {
      content_name: this.newsBoardContentName,
      record_date: this.createYYYYmmdd(this.newsBoardContentDate),
      remarks: this.remarks,
      url: this.contentSelected === 1 ? this.contentURL : '',
      time_stamp: this.newsBoardContentDetailData.time_stamp
    }

    if (this.contentSelected === 0 && this.fileName !== '') {
      if (this.uploadFile === null) {
        requestBody.file = await GetNewsBoardFileApi.getNewsBoardFileBlob(Number(this.newsBoardContentId))
      } else {
        requestBody.file = this.uploadFile
      }
    }

    const result = await NewsBoardContentEditApi.doNewsBoardContentEdit(this.newsBoardContentId, requestBody, this.fileName)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.newsBoardTitle + '記事編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      const path = '/news-board/' + this.newsBoardId
      this.$router.push(path).catch(e => {})
      this.showLoading = false
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
      this.showLoading = false
    }
  }

  private getNewsBoardDetail (newsBoardId: string) {
    (async () => {
      const result = await NewsBoardDetailApi.getDetail(newsBoardId)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.newsBoardDetailData = payload
        this.newsBoardName = payload.news_board_name
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private getNewsBoardContentDetail (newsBoardContentId: string) {
    (async () => {
      const result = await NewsBoardContentDetailApi.getDetail(newsBoardContentId)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.newsBoardContentDetailData = payload.news_board_content
        this.newsBoardContentName = payload.news_board_content.content_name
        this.newsBoardContentDate = this.displayDate(payload.news_board_content.record_date)
        this.contentSelected = this.choiceContentType(payload.news_board_content.content_url)
        this.fileName = this.getFileName(payload.news_board_content.content_file)
        this.remarks = payload.news_board_content.remarks
        if (payload.news_board_content.content_url !== '') {
          this.contentURL = payload.news_board_content.content_url
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private getFileName (filePath: string): string {
    const filePathArr = filePath.split('/')
    return filePathArr[filePathArr.length - 1]
  }

  private doNewsBoardContentDelete () {
    (async () => {
      const result = await NewsBoardContentDeleteApi.doNewsBoardContentDelete(this.newsBoardContentId)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.newsBoardTitle + '記事を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        const path = '/news-board/' + this.newsBoardId
        this.$router.push(path).catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
    })()
  }

  private selectedFile (e: any) {
    e.preventDefault()
    const files = e.target.files
    this.uploadFile = files[0]
    this.fileName = this.uploadFile.name
  }

  private cancelFile (e: any) {
    e.preventDefault()
    this.fileName = ''
    this.uploadFile = null
    const file = document.getElementById('file')
    if (file !== null) {
      (file as HTMLInputElement).value = ''
    }
  }

  private createYYYYmmdd (e: any) {
    const year = String(e.getFullYear())
    const month = '0' + String(e.getMonth() + 1)
    const day = '0' + String(e.getDate())
    return year + '-' + month.slice(-2) + '-' + day.slice(-2)
  }

  private displayDate (e: string): Date {
    const i = e.toString()
    const year = i.slice(0, 4)
    const month = i.slice(5, 7)
    const date = i.slice(8, 10)
    const monthInt = parseInt(month) - 1
    return new Date(Number(year), Number(monthInt), Number(date))
  }

  private choiceContentType (data: any): number {
    if (data !== '') {
      return 1
    } else {
      return 0
    }
  }

  private doCancel () {
    const path = '/news-board/' + this.newsBoardId
    this.$router.push(path).catch(e => {})
  }
}
